// extracted by mini-css-extract-plugin
export default {"sixthSection":"style_sixthSection__DZ3aU","sixthSectionCol":"style_sixthSectionCol__aTt0M","downloadApp":"style_downloadApp__kobHh"};